<!-- 产品矩阵 -->
<template>
  <section class="products" id="products">
    <div class="container">
      <div class="section-title">
        <h2>核心产品矩阵</h2>
        <p>以科技守护校园安全与成长，构建智慧教育新基建</p>
      </div>
      <div class="product-grid">
        <div class="product-card large" :class="{ 'has-warning': hasWarning('video-phone') }" @click="viewDetail('video-phone')">
          <div class="product-bg video-phone-bg"></div>
          <div class="content">
            <h3>校园视频公话</h3>
            <p>人脸识别，高清视频通话<br>连接家庭与校园</p>
            <span class="link">了解更多 →</span>
          </div>
        </div>
        
        <div class="product-right">
          <div 
            class="product-card" 
            v-for="product in products" 
            :key="product.id" 
            :class="{ 'has-warning': hasWarning(product.id) }"
            @click="viewDetail(product.id)"
          >
            <div class="product-bg" :class="product.id + '-bg'"></div>
            <div class="warning-icon" v-if="hasWarning(product.id)">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2L1 21h22L12 2zm0 3.99L19.53 19H4.47L12 5.99zM11 16h2v2h-2v-2zm0-6h2v4h-2v-4z"/>
              </svg>
            </div>
            <div class="content">
              <h3>{{ product.name }}</h3>
              <p>{{ product.desc1 }},{{ product.desc2 }}</p>
              <!-- <p>{{ product.desc2 }}</p> -->
              <span class="link">了解更多 →</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProductMatrix',
  data() {
    return {
      // 需要显示警告图标的产品ID
      warningProducts: ['anti-bullying', 'moral-eval'],
      products: [
        { id: 'class-card', name: '电子班牌系统', desc1: '通知发布、课堂互动',desc2:'班级管理数字化' },
        { id: 'ai-voice', name: 'AI数字人语音交互系统', desc1: '自然对话，精准理解',desc2:'随问随答' },
        { id: 'ai-book', name: 'AI数字人图书检索系统', desc1: '智能检索，精准推荐',desc2:'让阅读更简单高效' },
        { id: 'anti-bullying', name: '防霸凌预警系统', desc1: 'AI行为识别与预警',desc2:'构建安全校园防护网' },
        { id: 'ai-psychology', name: 'AI数字人心理咨询系统', desc1: '智能倾听，暖心陪伴',desc2:'提供专业的心理支持' },
        { id: 'moral-eval', name: '德育评价系统', desc1: '多维评价，过程记录',desc2:'助力德育工作科学化' }
      ]
    }
  },
  methods: {
    hasWarning(productId) {
      return this.warningProducts.includes(productId)
    },
    viewDetail(productId) {
      // console.log('View detail:', productId);
      // 触发事件给父组件 App.vue
      this.$emit('show-detail', productId)
      this.$emit('select-product', productId); // 触发导航栏高亮
    }
  }
}
</script>

<style scoped>
/* 整体section */
.products {
  padding: 100px 0;
  background: #f8f9fa;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
}

/* 标题区域 */
.section-title {
  text-align: center;
  margin-bottom: 60px;
}

.section-title h2 {
  font-size: 36px;
  color: #1a1a1a;
  margin-bottom: 12px;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.section-title p {
  font-size: 16px;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

/* 产品网格布局 */
.product-grid {
  display: grid;
  grid-template-columns: 1fr 1.8fr;
  gap: 24px;
  align-items: stretch;
}

/* 产品卡片基础样式 */
/* .product-card {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  min-height: 240px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 28px;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  color: #fff;
}

.product-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
} */

/* 背景图片层 - 在这里添加您的背景图 */
.product-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /* opacity: 0.3; */
  transition: opacity 0.3s;
  z-index: 0;
}

/* .product-card:hover .product-bg {
  opacity: 0.4;
} */

/* 各个产品的背景图 - 替换url为您的图片路径 */
.video-phone-bg {
  background-image: url('@/assets/video-phone.png');
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
}

.class-card-bg {
  background-image: url('@/assets/class-card.png');
  /* background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); */
}

.ai-voice-bg {
  background-image: url('@/assets/ai-voice.png');
  /* background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); */
}

.ai-book-bg {
  background-image: url('@/assets/anti-bullying.png');
  /* background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%); */
}

.anti-bullying-bg {
  background-image: url('@/assets/ai-psychology.png');
  /* background: linear-gradient(135deg, #fa709a 0%, #fee140 100%); */
}

.ai-psychology-bg {
  background-image: url('@/assets/anti-bullying.png');
  /* background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%); */
}

.moral-eval-bg {
  background-image: url('@/assets/ai-psychology.png');
  /* background: linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%); */
}

/* 产品卡片基础样式 */
.product-card {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  min-height: 240px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* 改为从顶部开始 */
  align-items: flex-start; /* 左对齐 */
  padding: 28px;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  color: #fff;
  text-align: left; /* 文字左对齐 */
}

.product-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

/* 内容层 */
.content {
  position: relative;
  z-index: 1;
  width: 70%;
}

.product-card h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
  line-height: 1.3;
  color: #fff;
  text-align: left;
}

.product-card p {
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 16px;
  color: rgba(255, 255, 255, 0.9);
  opacity: 0.95;
  text-align: left;
}

/* 左侧大卡片样式调整 */
/* .product-card.large {
  min-height: 520px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  justify-content: flex-start; 
}

.product-card.large h3 {
  font-size: 28px;
  margin-bottom: 16px;
}

.product-card.large p {
  font-size: 16px;
  margin-bottom: 24px;
} */

/* 右侧网格 */
.product-right {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 24px;
}

/* 警告图标 */
.warning-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  backdrop-filter: blur(10px);
}

.warning-icon svg {
  width: 18px;
  height: 18px;
  color: #fff;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.1);
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .product-grid {
    grid-template-columns: 1fr;
  }
  
  .product-right {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .product-card.large {
    min-height: 400px;
  }
}

@media (max-width: 768px) {
  .container {
    padding: 0 20px;
  }
  
  .section-title h2 {
    font-size: 28px;
  }
  
  .product-grid {
    gap: 16px;
  }
  
  .product-right {
    grid-template-columns: 1fr;
  }
  
  .product-card {
    padding: 24px;
    min-height: 200px;
  }
  
  .product-card.large {
    min-height: 350px;
  }
  
  .product-card h3 {
    font-size: 18px;
  }
  
  .product-card.large h3 {
    font-size: 24px;
  }
}

/* 添加加载动画 */
.product-card {
  animation: fadeInUp 0.6s ease-out;
}

.product-card:nth-child(1) { animation-delay: 0.1s; }
.product-card:nth-child(2) { animation-delay: 0.2s; }
.product-card:nth-child(3) { animation-delay: 0.3s; }
.product-card:nth-child(4) { animation-delay: 0.4s; }
.product-card:nth-child(5) { animation-delay: 0.5s; }
.product-card:nth-child(6) { animation-delay: 0.6s; }
.product-card:nth-child(7) { animation-delay: 0.7s; }

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/* 左侧大卡片样式调整 */
.product-card.large {
  min-height: 520px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  justify-content: flex-start;
}

/* 大图标题和描述文字改为黄色 */
.product-card.large h3,
.product-card.large p {
  color: #1a1a1a; /* 金黄色 */
}


/* "了解更多"链接改为 #2f9cd0 */
.product-card.large .link {
  color: #2f9cd0;
  font-weight: 600;
}


.product-card.large:hover .link::after {
  width: 100%;
}

/* 悬停时链接颜色加深 */
.product-card.large:hover .link {
  color: #1a7bb8;
}
</style>